export const parseQuery = (str) => {
    const pairs = str.split('&')
    return pairs
        .map((pair) => pair.split('='))
        .reduce(
            (query, [key, value]) => ({
                ...query,
                [decodeURIComponent(key)]: decodeURIComponent(value),
            }),
            {},
        )
}
